import React from "react";
import { StyledAccordionTitle, StyledArrowIcon, StyledArrowWrapper, StyledAccordionButton } from "../styled";
export var AccordionTitle = function (_a) {
    var backgroundColour = _a.backgroundColour, titleColor = _a.titleColor, titleFontSize = _a.titleFontSize, title = _a.title, isOpen = _a.isOpen, onClick = _a.onClick;
    return (React.createElement(StyledAccordionTitle, { backgroundColour: backgroundColour, onClick: onClick },
        React.createElement(StyledArrowWrapper, null,
            React.createElement(StyledArrowIcon, { fill: titleColor, isOpen: isOpen })),
        typeof title === "string" ? (React.createElement(StyledAccordionButton, { titleColor: titleColor, titleFontSize: titleFontSize, onClick: onClick }, title)) : (React.createElement(React.Fragment, null, title))));
};
